import translation from 'translation';


const metricsTypes = ['integer', 'currency', 'percent'];

const validateType = (type) => Boolean(metricsTypes.includes(type.toLowerCase()));

/**
 * @typedef {Object} MetricMetaParams
 * @property {string} id
 * @property {string} name
 * @property {string|null} shortName
 * @property {'integer'|'currency'|'percent'} type
 * @property {boolean} isGrowthPositive
 * @property {boolean} shouldTranslateName
 */

/**
 * @typedef {Object} MetricMeta
 * @property {string} id
 * @property {string} name
 * @property {string} shortName
 * @property {'integer'|'currency'|'percent'} type
 * @property {boolean} isGrowthPositive
 */

/**
 * @param {MetricMetaParams} params
 * @returns {MetricMeta}
 */

export function generateMetricsMeta (
  {id,
    name: passedName,
    shortName: passedShortName,
    type,
    isGrowthPositive,
    shouldTranslateName}
) {

  try {

    if (!validateType(type)) {
      throw new Error('такой type не предусмотрен');
    }

    let translatedName;
    let translatedeShortName;

    if (shouldTranslateName) {
      translatedName = id === 'a_goal_completions' ? translation.trc('bidmanager', passedName) : translation.tr(passedName);
      translatedeShortName = passedShortName ? translation.tr(passedShortName) : translatedName;
    }

    return {
      id,
      name: translatedName || passedName,
      shortName: translatedeShortName || translatedName || passedName,
      type,
      isGrowthPositive
    };

  } catch (err) {
    console.error(err.message);

  }
}
